import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';
import { JaldeeReportService } from 'src/app/services/jaldee-report.service';

@Component({
  selector: 'app-add-note',
  templateUrl: './add-note.component.html',
  styleUrls: ['./add-note.component.css']
})
export class AddNoteComponent implements OnInit {
  addnoteForm: UntypedFormGroup;
  formErrors = {

    'notes': ''


  };
  ValidationMessages = {

    'notes': {
      'required': 'Phone number is Required',
      'pattern': 'Only numbers are allowed'
    }
  };
  invoiceId: any;
  notes: any;
  api_error: any;
  api_success: string;
  disableConfirmbtn = false;
  reimburse: any = [];
  constructor(private formbuilder: UntypedFormBuilder,
    private jaldeeReportService: JaldeeReportService,
    private reportService: JaldeeReportService,
        private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private accountService: AccountService) {
    this.addnoteForm = this.formbuilder.group({

      notes: [''],
    });
    console.log(this.data);
    this.invoiceId = this.data.invoiceId;
    
  }

  ngOnInit() {
    // this.updateContactForm(this.ContactInfoDeatils);
    this.getReimburseReportDetails(this.invoiceId)
  }
  
  addNotes() {
    this.api_error = '';
    this.api_success = '';
    // this.logValidationErrors();
    console.log(this.addnoteForm.get('notes').value);
    const data = {
      'notes': this.addnoteForm.get('notes').value

    };
    this.jaldeeReportService.addNotes(this.invoiceId , data)
        .subscribe(res => {
          this.api_success = 'Note added successfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
            }, 2000);
        },
          (error) => {
            this.disableConfirmbtn = false;
            this.api_error = error.error;
           }
        );
  }
  getReimburseReportDetails(invoiceId) {
    this.reportService.getReimbursePaymentDetails(invoiceId)
    .subscribe(reimburseRes => {
      this.reimburse = reimburseRes;
      this.updateContactForm(this.reimburse)
      console.log(this.reimburse);
    },
      (error) => {
        console.log(error.error);
      });
  }
  updateContactForm(reimburse) {
    console.log(reimburse[0].notes);
    this.addnoteForm.patchValue({
     
      notes: reimburse[0].notes,
    });

  }
}
